import React, { useState, useEffect } from "react";

const ThemeToggle = () => {
  const [isDark, setIsDark] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem("solvio_theme");
    if (saved === "light") {
      setIsDark(false);
      document.body.classList.add("light-mode");
    }
  }, []);

  const toggle = () => {
    if (isDark) {
      document.body.classList.add("light-mode");
      localStorage.setItem("solvio_theme", "light");
    } else {
      document.body.classList.remove("light-mode");
      localStorage.setItem("solvio_theme", "dark");
    }
    setIsDark(!isDark);
  };

  return (
    <button
      onClick={toggle}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      style={{
        background: "none",
        border: "1px solid rgba(10,107,90,0.3)",
        borderRadius: "999px",
        padding: "0.35rem 0.75rem",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "0.4rem",
        fontSize: "0.8rem",
        color: isDark ? "#c3b996" : "#0a6b5a",
        transition: "all 0.2s",
      }}
    >
      <i className={`fa-solid ${isDark ? "fa-sun" : "fa-moon"}`}></i>
      {isDark ? "Light" : "Dark"}
    </button>
  );
};

export default ThemeToggle;
